import { createSelector } from 'reselect';

import getSelectors from '../../shared/store/selectorsFactory';

import { adminPageNames } from '../../shared/adminPageNames';

export const sharedSelectors = getSelectors(adminPageNames.TAX_ACCOUNTING);

export const enabledFlagOptionsSelector = createSelector(
  state => state.administration[adminPageNames.TAX_ACCOUNTING].enabledFlagValues,
  enabledFlagValues => enabledFlagValues.map(({ name, value }) => ({ label: name, value }))
);

export const plAccountOptionsSelector = state =>
  state.administration[adminPageNames.TAX_ACCOUNTING].plAccountValues;

export const bsAccountOptionsSelector = state =>
  state.administration[adminPageNames.TAX_ACCOUNTING].bsAccountValues;

export const reclassPlAccountOptionsSelector = state =>
  state.administration[adminPageNames.TAX_ACCOUNTING].reclassPlAccountValues;

export const reclassBsAccountOptionsSelector = state =>
  state.administration[adminPageNames.TAX_ACCOUNTING].reclassBsAccountValues;

export const taxDescriptionNamesOptionsSelector = state =>
  state.administration[adminPageNames.TAX_ACCOUNTING].taxDescriptionNames;

export const isFetchingInitialDataForModalSelector = state =>
  state.administration[adminPageNames.TAX_ACCOUNTING].isFetchingInitialDataForModal;
